// src/api/references.ts
//
// The shared referral-source list behind the Reference field on the Client and
// Vendor forms. Clients and vendors share one backend table, so they share one
// list here too.
import api from './api';

export interface DirectoryReference {
  id: string;
  name: string;
  created_at?: string | null;
}

export const referencesApi = {
  // Swallows read failures on purpose: the dropdown degrades to "no options
  // yet, type to add one" rather than blocking the form or firing a toast.
  list: async (): Promise<DirectoryReference[]> => {
    try {
      const res = await api.get('/references');
      return res.data?.items ?? [];
    } catch {
      return [];
    }
  },

  // Get-or-create. `created` is false when the name already existed, which the
  // Settings page surfaces as "this reference already exists".
  create: async (name: string): Promise<{ reference: DirectoryReference; created: boolean }> => {
    const res = await api.post('/references', { name });
    return res.data;
  },

  rename: async (id: string, name: string): Promise<DirectoryReference> => {
    const res = await api.patch(`/references/${id}`, { name });
    return res.data.reference;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/references/${id}`);
  },
};

export default referencesApi;
